<div *ngIf="showBanner" class="maintenance-banner"
     [class.maintenance-banner--active]="phase === 'active'"
     [class.maintenance-banner--complete]="phase === 'complete'">
  <span class="maintenance-banner__icon material-icons">
    {{ phase === 'active' ? 'warning' : phase === 'complete' ? 'check_circle' : 'schedule' }}
  </span>

  <p class="maintenance-banner__text">
    <!-- <strong>{{ phase === 'active' ? 'Maintenance In Progress' : phase === 'complete' ? 'Maintenance Complete' : 'Scheduled Maintenance' }}:</strong> -->
    <strong>Notification:</strong>
    {{ message }}
  </p>
  <button class="maintenance-banner__close" (click)="closeBanner()" aria-label="Dismiss">
    <span class="material-icons">close</span>
  </button>
</div>
